export const reduceInviteTeamMemberRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isInvitingTeamMember: true },
  };
};

export const reduceInviteTeamMemberSuccess = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isInvitingTeamMember: false },
  };
};

export const reduceInviteTeamMemberFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isInvitingTeamMember: false },
  };
};
